<template>
  <div class="regulatory-contract">
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        height="300"
        :columns="columnList"
      >
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { baseColumnListDefault } from './index.js';
  //import superviseBillApi from '@/api/park/superviseBill';
  export default {
    name: 'stockDetailTable',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        multipleSelection: [], // 表格被选中的行数据
        checkRowKeys: [],
        menuButtonList: [], // 表格功能按钮
        supervisionBillStatusList: [], // 监管单状态状态
        contractNatureList: [], // 合同性质
        parkCompanyList: [], // 园区公司
        columnList: [],
        loading: false,
        selectionList: [],
      };
    },
    computed: {},
    mounted() {
      this.getColumnInfo();
    },
    methods: {
      //获取当前列
      getColumnInfo() {
        this.columnList = baseColumnListDefault;
      },
      // 得到表格数据
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    watch: {
      tableDataList: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
